import { useSort } from "~/pages/inventory/hooks/useSort";
import {
  CheckScoreOrder,
  CheckScoreOrderField,
  OrderDirection,
  useGetCheckScoresQuery,
} from "~/operations";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { usePolicyOutletContext } from "~/components/policy-gql/policy-gql";
import { useSearch } from "~/components/search/useSearch";
import { ASSET_TABLE_INITIAL_PAGE_RANGE } from "~/components/pagination";
import { usePaginate } from "~/components/pagination/usePaginate";
import { ExposedAsset } from "../types";

type UseAffectedAssetsParams = {
  scope: SpaceOrWorkspaceScope;
};

// THIS IS A HOLDOVER UNTIL FINDINGS (OR SOMEOTHER IMPLEMENTATIONO) CAN SUPPORT ASSETS AT THE POLICY LEVEL
export function usePolicyAssets({ scope }: UseAffectedAssetsParams) {
  const { searchFilters } = useSearch();
  const { policy } = usePolicyOutletContext();

  const paginate = usePaginate({
    defaultPageSize: ASSET_TABLE_INITIAL_PAGE_RANGE.to,
  });

  const sort = useSort<CheckScoreOrder>({
    defaultSort: {
      field: CheckScoreOrderField.RiskValue,
      direction: OrderDirection.Desc,
    },
    validFields: [CheckScoreOrderField.Score, CheckScoreOrderField.AssetName],
  });

  const {
    data: checkData,
    error,
    loading,
    fetchMore,
  } = useGetCheckScoresQuery({
    variables: {
      entityMrn: scope.mrn,
      ...paginate.pageVars,
      orderBy: sort.orderBy,
      filter: {
        queryTerms: searchFilters,
        policyMrn: policy.mrn,
      },
    },
  });

  const checkScores =
    checkData?.checkScores?.__typename === "CheckScoresConnection"
      ? checkData.checkScores
      : undefined;

  const { edges, pageInfo, filteredTotalCount } = checkScores || {};

  const assets = edges?.flatMap(({ node }) => {
    if (!node?.asset) return [];

    const asset: ExposedAsset = {
      isAffectedAsset: true,
      id: node.asset.id,
      mrn: node.asset.mrn,
      assetMrn: node.asset.mrn,
      score: node.riskValue || 0,
      lastUpdated: node.lastUpdated ?? "",
      riskFactors: node.riskFactors,
      title: node.asset.name,
      iconId: node.asset.icon,
      tags: node.tags ? [...node.tags] : [],
      rating: node.rating,
      exception: node.exception,
      state: node.state,
      __typename: node.__typename,
    };

    // Manually add the platform tag
    if (node.platform) {
      asset.tags?.push({
        key: "Platform",
        value: node.platform.title,
        __typename: "Tag",
      });
    }

    return [asset];
  });
  //     defaultSort: {
  //       field: FindingsOrderField.RiskValue,
  //       direction: OrderDirection.Desc,
  //     },
  //     validFields: [
  //       FindingsOrderField.AssetName,
  //       FindingsOrderField.LastUpdated,
  //       FindingsOrderField.RiskValue,
  //     ],
  //   });

  //   const { data, error, fetchMore, loading } = useGetAffectedAssetsQuery({
  //     variables: {
  //       scopeMrn: scope.mrn,
  //       first: 10,
  //       orderBy,
  //       filter,
  //     },
  //   });

  //   const findingsUnion = data?.findings;
  //   const findings =
  //     findingsUnion?.__typename === "FindingsConnection"
  //       ? findingsUnion
  //       : undefined;

  //   const assets = findings?.edges?.flatMap(({ node }) => {
  //     if (!node) return [];

  //     const asset = {
  //       id: node.asset?.id || "",
  //       mrn: node.asset?.mrn || "",
  //       score: node.riskValue || 0,
  //       lastUpdated: node.lastUpdated,
  //       riskFactors: node.riskFactors,
  //       title: node.asset?.name || "",
  //       iconId: node.asset?.icon,
  //       tags: node.asset?.tags,
  //       rating: node.rating,
  //     };

  //     return [asset];
  //   });

  return {
    assets,
    sort,
    paginate,
    filteredTotalCount: filteredTotalCount || 0,
    fetchMore,
    pageInfo: pageInfo,
    error,
    loading,
  };
}
